@if (label()) {
    <p-floatlabel [variant]="labelVariant()">
        <ng-container [ngTemplateOutlet]="control" />
        <label [attr.for]="inputId()">
            {{ label() }}
            @if (required()) {
                <span>*</span>
            }
        </label>
    </p-floatlabel>
} @else {
    <ng-container [ngTemplateOutlet]="control" />
}
<ng-template #control>
    <textarea
        pTextarea
        [id]="inputId()"
        [placeholder]="placeholder() ?? ''"
        [rows]="rows()"
        [invalid]="showInvalid()"
        [disabled]="disabled()"
        [style]="fullWidthStyle"
        [value]="value()"
        (input)="handleInput($event)"
        (blur)="markTouched()"></textarea>
</ng-template>
@if (showError() && errorMessage(); as message) {
    <small class="kno2-form-control">{{ message }}</small>
}
